/**
 * Dev-only logger. No-op in production builds.
 * Keeps debug info during development without leaking noise in prod.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
